export  function studentsSlider() {
    let prefix = "students-slider-";
    let initializedName = prefix + "initialized";


    $(".students-slider").each(function () {
        let $slider = $(this);

        if (!$slider.hasClass(initializedName)) {
            $slider.addClass(initializedName);
            
            let thumbs = new Swiper($slider.find("." + prefix + "thumbs")[0], {
                slidesPerView: 1,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
            });

            new Swiper($slider.find("." + prefix + "blockquote")[0], {
                watchOverflow: true,
                slidesPerView: 1,
                pagination: {
                    el: $slider.find(".swiper-pagination")[0],
                    clickable: true,
                },
                thumbs: {
                    swiper: thumbs,
                },
            });
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/studentsSlider.js